import { RESET_DATASET } from 'store';

import { SET_TEST_SELECTION } from './types';
import { RESET_BOOTSTRAP_CIS } from '../types';

export default (state = null, action) => {
  switch (action.type) {
    case SET_TEST_SELECTION:
      return action.testSelection;
    case RESET_DATASET:
    case RESET_BOOTSTRAP_CIS:
      return null;
    default:
      return state;
  }
};
